import { get } from "lodash-es";
import { useDelaysReportContext } from "../context/DelaysReportContext";
import { getShiftsAndCrews } from "../repositories/DelaysReportRepository";

export const useSearchShiftsAndCrews = () => {
	const {
		actions: {
			setShiftsList,
			setCrewsList,
			setIsLoadingShifts,
			setIsLoadingCrews,
		},
	} = useDelaysReportContext();

	return async () => {
		setIsLoadingShifts(true);
		setIsLoadingCrews(true);
		setShiftsList([]);
		setCrewsList([]);

		const res = await getShiftsAndCrews();
		if (res.ok) {
			const rowsSource = get(res, "data", []);
			const shifts = rowsSource?.tables[0].rows;
			const crews = rowsSource?.tables[1].rows;
			const shiftsWithAll = [{ Shift: "All" }, ...shifts];
			const crewsWithAll = [{ Crew: "All" }, ...crews];

			setShiftsList(shiftsWithAll);
			setCrewsList(crewsWithAll);
		}

		setIsLoadingShifts(false);
		setIsLoadingCrews(false);
	};
};
